<template lang="pug">
div
  .ride-container-v1()
    .ride-title {{isEbike()?'助力车骑行卡':'单车月卡'}}
    .ride-go-mycard(v-if="rideStatue!==0" @click="goMycard")
      .text() 您有其他卡生效中，查看全部卡
      .icon
      //- div 我的骑行卡
      //- img(src="https://m.hellobike.com/resource/helloyun/08345/MJGujh4N2B.png?x-oss-process=image/format,webp")
    //- .ride-tips(v-if="rideTipsShow")
    //-   .ride-tips--icon(@click="closeRideTips")
    //-   .ride-tips--text(v-if="rideTips && rideTips.text") {{rideTips.text}}
    //-     span.ride-tips--highlight(v-if="rideTips && rideTips.highlight") {{rideTips.highlight}}
    ride-month-template(
      :type="cardType"
      :status="rideStatue===0?'receivable':'wait-for-receive'"
      :totalCardDays="totalCardDays"
      :totalCardTimes="totalCardTimes"
      :rideStatue="rideStatue"
      :cityNames="cityNames"
      :rideFreeMinute="rideFreeMinute"
      :rideDays="rideDays"
      :cardsStatus="status"
      :rideTimes="rideTimes"
      :isOpen="true"
      @goUse="goUse"
      :showRideCardTouting="showRideCardTouting"
      :cardStatus="cardStatus"
      :rideCardInfoValue="rideCardInfoValue"
      :isLotteryNew="isLotteryNew"
      :payAmount="payAmount"
      :isApp="isApp"
    )
      .card-button(
        v-if="showRideCardTouting"
        :class="isEbike() ? 'ebike' : 'ride'"
      )
        button(
          @click="pickCoupon"
        ) 领取
    .ride-bottom(v-if="showAppUseBar")
      .ride-bootom-left 限哈啰APP使用
      .ride-bootom-right(@click="goUrl")
        div 去使用
        img.gouse-img(src="https://m.hellobike.com/resource/helloyun/22871/WWWW0_Group%20572.png")

</template>
<script>
import { env } from '@hb/hbridge';
import config from '@/const/config';
import {
  submitTired,
} from '@/api/vip';
import {
  getTokenAndKey,
  safeGet,
} from '@/utils';
import { Toast } from 'vant';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { RIDE_CARD_STATUS } from '../../consts';
import RideMonthTemplate from './ride-month-template.vue';

const rideTipsEnum = {
  notEnable: {
    text: '你有骑行卡生效中，已发放的',
    highlight: '全国卡可按需手动启用',
  },
  notEnableIncludeAc: {
    text: '全国卡生效中，已发卡将在当前卡失效后自动启用',
    highlight: null,
  },
};


export default {
  components: {
    RideMonthTemplate,
  },
  props: {
    groups: {
      type: Object,
      default: null,
    },
    propVersion: {
      type: String,
      default: '',
    },
    isLotteryNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rideStatue: null,
      rideDays: null,
      rideTimes: null,
      status: null, // 领取状态
      env,
      totalCardDays: null, // 天
      totalCardTimes: null, // 次
      cityNames: null,
      rideFreeMinute: null, // 时间
      v2Bg: 'background:#2fa8fa',
      vBgEbike: 'background: linear-gradient(90deg, #25C0F5 0%, #00AFEA 100%);',
      cardMap: RIDE_CARD_STATUS,
      cardStatus: null,
      showRideCard: true,
      rideTipsShow: false,
      rideTips: null,
      showRideCardTouting: false,
      rideCardInfoValue: false,
      payAmount: 0,
      isApp: false,
    };
  },
  computed: {
    showAppUseBar() {
      return (env.isAliMP || env.isAliMPMonitor || env.isAlipayBrowser) && this.propVersion && ['ride_app', 'ladder_app', 'ride_ebike_app'].includes(this.propVersion);
    },
    cardType() {
      if (this.payAmount > 0) {
        return 'oneCentRide';
      }
      return this.isEbike() ? 'ebike' : 'ride';
    },
  },
  watch: {
    // watch groups
    groups() {
      this.init();
    },

  },
  mounted() {
    this.init();
  },
  methods: {
    getCardBg(version) {
      if (version.includes('ebike')) {
        return this.vBgEbike;
      }
      return this.v2Bg;
    },
    isEbike() {
      if (this.propVersion) {
        return this.propVersion.includes('ebike');
      }
      return false;
    },
    goUse() {
      if (this.showRideCardTouting) {
        this.pickCoupon();
      } else if (this.groups && this.groups.coupons && Array.isArray(this.groups.coupons)) {
        this.$emit('useRide', this.groups.coupons[0]);
      }
    },
    goUrl() {
      this.$emit('gourl');
    },
    goMycard() {
      if (env.isEasyBikeApp) {
        window.location.href = 'hellobike://hellobike.com/moped/business/htr_my_card_page';
      } else {
        window.location.href = `https://m.hellobike.com/AppHelloBikeMainH5/${config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/my-cards?adsource=`;
      }
    },
    pickCoupon() {
      const coupon = safeGet(this, 'groups.propList.0');
      this.$emit('click-btn', { ...(coupon || {}), showLadderCoupon: false });

      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_card_button',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    async closeRideTips() {
      try {
        const { token } = await getTokenAndKey();
        const { code, msg } = await submitTired({
          scene: 'rideCardEnableTips',
          token,
        }) || {};
        if (code !== 0) {
          Toast.show(msg);
        }
        this.rideTipsShow = false;
        this.clickRideTipsButton();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    },
    init() {
      if (this.groups && this.groups.propList) {
        this.showRideCardTouting = safeGet(this, 'groups.propList.0.status') === 1;
        if (this.groups.propList[0].rideCardInfo) {
          this.rideCardInfoValue = true;
          this.rideDays = this.groups.propList[0].rideCardInfo.remainDays;
          this.rideTimes = this.groups.propList[0].rideCardInfo.useProperty.remainCardTimes;
          this.rideStatue = this.groups.propList[0].rideCardInfo.status;
          this.totalCardDays = this.groups.propList[0].rideCardInfo.useProperty.totalCardDays;
          this.totalCardTimes = this.groups.propList[0].rideCardInfo.useProperty.totalCardTimes;
          const tipsType = safeGet(this, 'groups.propList.0.rideCardInfo.tipsType');
          this.rideTipsShow = Object.keys(rideTipsEnum).includes(tipsType);
          this.rideTips = rideTipsEnum[tipsType];
          this.payAmount = safeGet(this, 'groups.propList.0.rideCardInfo.deductRule.payAmount') || 0;
          this.isApp = safeGet(this, 'groups.propList.0.rideCardInfo.useRuleProperty.usePlatform', -1) === 0;


          if (this.groups.propList[0].rideCardInfo
            && this.groups.propList[0].rideCardInfo.useRuleProperty
            && Array.isArray(this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames)) {
            if (this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames.length > 0) {
              if (this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames.length > 1) {
                this.cityNames = `限${this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames[0]}...`;
              } else {
                // eslint-disable-next-line prefer-destructuring
                this.cityNames = `限${this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames[0]}`;
              }
            } else {
              this.cityNames = '全国通用';
            }
          } else {
            this.cityNames = '全国通用';
          }
          if (this.groups.propList[0].rideCardInfo.deductRule.reduceType === 1) {
            this.rideFreeMinute = `${this.groups.propList[0].rideCardInfo.deductRule.rideFreeMinute}分钟`;
          } else if (this.groups.propList[0].rideCardInfo.deductRule.reduceType === 2) {
            this.rideFreeMinute = `${this.groups.propList[0].rideCardInfo.deductRule.rideDiscount}折`;
          } else if (this.groups.propList[0].rideCardInfo.deductRule.reduceType === 0) {
            this.rideFreeMinute = `${this.groups.propList[0].rideCardInfo.deductRule.rideFreeCost}元`;
          } else {
            this.rideFreeMinute = '';
          }
          this.cardStatus = this.groups.propList[0].rideCardInfo.status;
        } else if (!this.propVersion.includes('ebike')) {
          this.showRideCard = false;
        } else {
          this.showRideCard = true;
          this.rideCardInfoValue = false;
        }
      }
      if (this.groups && this.groups.coupons && Array.isArray(this.groups.coupons)) {
        this.status = this.groups.coupons[0].status;
      }


      if (this.rideTipsShow) {
        this.rideTipsExpose();
      }

      if (this.showRideCardTouting) {
        this.exposeRideCardTouting();
      }
    },

    rideTipsExpose() {
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_cards_remind',
        contentId: 'platform_cards_remind',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    clickRideTipsButton() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_cards_remind',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    exposeRideCardTouting() {
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_card_button',
        contentId: 'platform_card_button',
        exposureTimes: 1,
        businessInfo: {},
      });
    },


  },
};
</script>
<style lang="less" scoped>
.ride-container-v1 {
  margin: 0.06rem 0.1rem 0.1rem 0.1rem;
  background: #fff;
  padding: 0.1rem 0.15rem 0.12rem 0.15rem;
  border-radius: 0.16rem;
  position: relative;

  .ride-title {
    margin-top: 0.03rem;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.16rem;
    font-weight: 500;
    line-height: 0.22rem;
  }

  .ride-go-mycard {
    position: absolute;
    top: 0.1rem;
    right: 0.08rem;
    color: rgba(125, 59, 42, 1);
    font-family: PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 0.24rem;
    background-image: url(https://m.hellobike.com/resource/gallery/350/NZukFVJ9_toOpen.png);
    background-repeat: no-repeat;
    background-size: 100%;

    .icon {
      width: 0.12rem;
      height: 0.12rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/MJGujh4N2B.png);
      background-repeat: no-repeat;
      background-size: 100%;
      margin-top: 0.01rem;
    }

    img {
      margin-top: 0.03rem;
      width: 0.12rem;
      height: 0.12rem;
    }
  }

  .ride-card {
    margin-top: 0.1rem;
    width: 100%;
    height: 0.72rem;
    background: linear-gradient(90deg, #fc932e 0%, #f75918 100%);
    position: relative;
    border-radius: 0.1rem;

    .ride-card-info {
      color: #fff;
      padding-top: 0.14rem;
      margin-left: 0.16rem;

      .ride-card-info-lineOne {
        font-size: 0.16rem;
        margin-bottom: 0.02rem;
        font-weight: 600;
        line-height: 0.26rem;
      }

      .ride-card-info-lineTwo {
        font-size: 0.12rem;
      }
    }

    .ride-num {
      position: absolute;
      top: 0.18rem;
      right: 0.2rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.14rem;
      font-weight: 400;
      color: #fff;
      line-height: 0.36rem;

      .have-day {
        display: flex;

        .big-num {
          font-family: "DIN Alternate Bold", sans-serif;
          font-size: 0.26rem;
          font-weight: 500;
        }

        .small-sign {
          line-height: 0.42rem;
        }
      }

      .can-use-v2 {
        min-width: 0.74rem;
        height: 0.32rem;
        background: #fff;
        color: #08f;
        font-size: 0.15rem;
        text-align: center;
        border-radius: 0.26rem;
        line-height: 0.32rem;
      }
    }

    .card-button {
      margin-right: 0.2rem;

      button {
        width: 0.74rem;
        height: 0.32rem;
        color: #08f;
        border-radius: 0.24rem;
        font-weight: 600;
        font-size: 0.15rem;
        line-height: 0.32rem;
        background: #fff;
      }
    }
  }

  .ride-gary {
    margin-top: 0.1rem;
    width: 100%;
    height: 0.72rem;
    background: #eef2f6;
    position: relative;
    border-radius: 0.1rem;
    color: #5a6066;

    .ride-card-info {
      padding-top: 0.14rem;
      margin-left: 0.16rem;

      .ride-card-info-lineOne {
        font-size: 0.16rem;
        margin-bottom: 0.1rem;
        font-weight: 600;
        line-height: 0.26rem;
      }

      .ride-card-info-lineTwo {
        font-size: 0.12rem;
      }
    }

    .ride-card-right {
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0 0.1rem 0 0.1rem;
      width: auto;
      height: 0.2rem;
      background: #b5c0cb;
      color: #fff;
      font-size: 0.12rem;
      text-align: center;
      line-height: 0.2rem;
      padding: 0 0.08rem 0 0.08rem;
    }
  }

  .ride-bottom {
    margin: 0 auto;
    width: 3.08rem;
    height: 0.32rem;
    background: #f4f8fa;
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    line-height: 0.32rem;
    padding: 0 0.1rem 0 0.15rem;
    border-radius: 0 0 0.1rem 0.1rem;

    .ride-bootom-left {
      color: #373b3e;
    }

    .ride-bootom-right {
      color: #242729;
      font-weight: 500;
      display: flex;

      img.gouse-img {
        margin-top: 0.1rem;
        width: 0.12rem;
        height: 0.12rem;
      }
    }
  }

  .ride-tips {
    display: flex;
    background: #fff6d9;
    height: 0.33rem;
    line-height: 0.33rem;
    border-radius: 0.08rem;
    color: #a47565;
    align-items: center;
    padding-left: 0.08rem;
    margin-top: 0.08rem;

    &--text {
      font-size: 0.12rem;
      margin-left: 0.01rem;
      position: relative;

      &::before {
        content: '';
        display: inline-block;
        width: 0;
        height: 0;
        border-width: 0.06rem;
        border-style: solid;
        border-color: transparent transparent #fff6d9 transparent;
        margin-right: 0.04rem;
        position: absolute;
        // 位置在右上角
        top: -0.12rem;
        right: -0.06rem;
      }
    }

    &--highlight {
      color: rgba(124, 62, 42);
    }

    &--icon {
      background: url('https://m.hellobike.com/resource/gallery/30/SqUOyYTST1.png?x-oss-process=image/quality,q_80') no-repeat;
      background-size: 0.14rem 0.14rem;
      width: 0.14rem;
      height: 0.14rem;
    }
  }
}
</style>
